import { render, staticRenderFns } from "./add-mat.vue?vue&type=template&id=29129ee9"
import script from "./add-mat.vue?vue&type=script&lang=js"
export * from "./add-mat.vue?vue&type=script&lang=js"
import style0 from "./add-mat.vue?vue&type=style&index=0&id=29129ee9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports